module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_null@2x.af13c03f.png";